import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';
import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getPpmDeleteObjectProps {
  store?: PpmRepository;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getPpmDeleteObject = ({ store, action, toggleVisiblity }: getPpmDeleteObjectProps): DialogObject => {
  return {
    title: `Suppression de Plan de passation des marchés`,
    description: 'Cet action est irréversible, veuillez reviser vos modifications avant de continuer',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
